import React from 'react';
import { L2_ICON_SIZES } from '../../constants';
import type { L2IconType } from '../../types';

const HireHourlyL2Icon = ({ size = 'sm' }: L2IconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={L2_ICON_SIZES[size]}
    height={L2_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 48 48"
  >
    <g filter="url(#hire_hourly_svg__a)">
      <rect width={35} height={31} x={3} y={13} fill="#fff" rx={2} />
      <rect width={34.5} height={30.5} x={3.25} y={13.25} stroke="#E4E5E7" strokeWidth={0.5} rx={1.75} />
      <path
        fill="#C5C6C9"
        fillRule="evenodd"
        d="M15.226 25.815A5.71 5.71 0 0 0 17 21.655C17 18.532 14.538 16 11.5 16S6 18.532 6 21.655c0 1.646.684 3.127 1.775 4.16.309-1.495 1.86-2.633 3.725-2.633 1.867 0 3.417 1.137 3.726 2.633M11.5 22.008c1.14 0 2.063-.95 2.063-2.12 0-1.172-.924-2.12-2.063-2.12s-2.062.948-2.062 2.12c0 1.17.923 2.12 2.062 2.12"
        clipRule="evenodd"
      />
      <path fill="#E8F094" d="M6 30h13v10H6z" />
      <path fill="#C5C6C9" d="M22 30h5v1.5h-5zM22 34h13v1.5H22zM22 38h13v1.5H22z" />
    </g>
    <g filter="url(#hire_hourly_svg__b)">
      <path fill="#fff" d="M33 28c-6.627 0-12-5.373-12-12S26.373 4 33 4s12 5.373 12 12-5.373 12-12 12" />
      <path
        stroke="#E4E5E7"
        strokeWidth={0.5}
        d="M21.25 16c0 6.49 5.26 11.75 11.75 11.75S44.75 22.49 44.75 16 39.49 4.25 33 4.25 21.25 9.51 21.25 16Z"
      />
    </g>
    <circle cx={33} cy={16} r={9.12} fill="url(#hire_hourly_svg__c)" />
    <path stroke="#fff" strokeWidth={1.5} d="M33 10.72v5.76l3.36 1.44" />
    <defs>
      <filter
        id="hire_hourly_svg__a"
        width={41}
        height={37}
        x={0}
        y={10}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1663_78711" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_1663_78711" result="shape" />
      </filter>
      <filter
        id="hire_hourly_svg__b"
        width={30}
        height={30}
        x={18}
        y={1}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1663_78711" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_1663_78711" result="shape" />
      </filter>
      <linearGradient
        id="hire_hourly_svg__c"
        x1={23.88}
        x2={49.192}
        y1={1.408}
        y2={9.959}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#005C25" />
        <stop offset={1} stopColor="#BBCE00" />
      </linearGradient>
    </defs>
  </svg>
);
HireHourlyL2Icon.displayName = 'HireHourlyL2Icon';
export default HireHourlyL2Icon;
